import { motion, useReducedMotion } from "framer-motion";
import MiniScene, { Lift, useSceneTheme } from "./MiniScene";
import { Greenhouse } from "./sceneSeason";
import { Kid, Puppy } from "./ArrivalScene";

const ease = [0.32, 0.72, 0, 1];
const GX = 128;
const GS = 0.95;
const DOOR = GX + 45 * GS;

// A potted plant walks past the waving kids into the greenhouse, the doors close and the glass glows.
export default function GreenhouseArt({ color = "#30A14E" }) {
  const reduce = useReducedMotion();
  const { season } = useSceneTheme();
  const door = (left) => ({ initial: reduce ? false : { scaleX: 0 }, animate: { scaleX: 1 }, transition: { delay: 1.45, duration: 0.35, ease }, style: { transformBox: "fill-box", transformOrigin: left ? "0% 50%" : "100% 50%" } });
  return (
    <MiniScene testid="greenhouse-art" pines={[[16, 30], [34, 22], [112, 22], [222, 34], [236, 24]]}>
      <Lift>
        <motion.g initial={reduce ? false : { opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, ease }}>
          <Greenhouse x={GX} s={GS} color={color} id="gh-art-glass">
            <motion.rect x="334" y="116" width="11" height="34" rx="1.5" fill={color} fillOpacity="0.85" {...door(true)} />
            <motion.rect x="345" y="116" width="11" height="34" rx="1.5" fill={color} fillOpacity="0.85" {...door(false)} />
            {!reduce && <motion.path d="M300 150 V92 L345 60 L390 92 V150 Z" fill={color} initial={{ opacity: 0 }} animate={{ opacity: [0, 0.26, 0.07] }} transition={{ delay: 1.75, duration: 0.9 }} />}
          </Greenhouse>
        </motion.g>
        <Kid x={52} girl reduce={reduce} d={0.3} season={season} />
        <Kid x={76} reduce={reduce} d={0.2} season={season} />
        <Puppy x={102} reduce={reduce} />
        <motion.g initial={reduce ? false : { x: -40, opacity: 0 }} animate={{ x: reduce ? DOOR - 22 : [-40, 60, DOOR - 22], y: reduce ? 0 : [0, -3, 0, -3, 0], opacity: 1 }} transition={{ duration: 1.1, delay: 0.35, ease, times: [0, 0.5, 1] }} data-testid="greenhouse-art-plant">
          <path d="M14 150 h16 l-2 -13 h-12 Z" fill="#C8754B" />
          <path d="M22 137 C22 125 18 119 12 117 C18 117 22 121 22 127 C22 119 26 113 34 113 C28 117 24 123 24 137 Z" fill={color} />
        </motion.g>
        {!reduce && [[GX + 8, 62], [GX + 80, 64], [GX + 92, 104], [GX - 6, 104], [DOOR, 52]].map(([x, y], i) => (
          <motion.path key={i} d={`M${x} ${y - 5} L${x + 1.4} ${y - 1.4} L${x + 5} ${y} L${x + 1.4} ${y + 1.4} L${x} ${y + 5} L${x - 1.4} ${y + 1.4} L${x - 5} ${y} L${x - 1.4} ${y - 1.4} Z`} fill="#FFD60A"
            initial={{ scale: 0, opacity: 0 }} animate={{ scale: [0, 1.2, 0], opacity: [0, 1, 0] }} transition={{ delay: 1.85 + i * 0.1, duration: 0.8 }} style={{ transformBox: "fill-box", transformOrigin: "50% 50%" }} />
        ))}
      </Lift>
    </MiniScene>
  );
}
